import React, { useEffect, useState } from 'react'
import SearchIcon from '@material-ui/icons/Search'
import injectStyles from 'react-jss'
import StyledIconButton from '../../Form/StyledIconButton'
import { styles } from './styled'
import { urlAdd } from '../../../Utils/URL'

const LiveMapSearchInput = props => {
  const { classes, suggestions = [], searchHandler, placeholder } = props
  const [text, setText] = useState('')
  const [localSuggestions, setLocalSuggestions] = useState([])
  const [openedSuggestions, setOpenedSuggestions] = useState(false)

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const tableSearch = urlParams.get('tableSearch')
    if (tableSearch) {
      setText(tableSearch)
      handleChanges(tableSearch)
    }
  }, [])

  const handleChanges = value => {
    urlAdd('tableSearch', value)
    setOpenedSuggestions(false)
    searchHandler(value)
  }

  const onChangeSearch = text => {
    setText(text)
    if (!text) {
      setOpenedSuggestions(false)
      return
    }

    let newSuggestions = suggestions.filter(s =>
      s.toLowerCase().includes(text.toLowerCase()),
    )

    setLocalSuggestions(newSuggestions)
    setOpenedSuggestions(true)
  }

  return (
    <div className={classes.container}>
      <div className={classes.inputContainer}>
        <input
          className={classes.input}
          onChange={event => {
            onChangeSearch(event.target.value)
          }}
          value={text}
          onKeyUp={event =>
            event.keyCode === 13 || !event.target.value
              ? handleChanges(text)
              : ''
          }
          placeholder={
            placeholder ? placeholder : 'Search client or campaign...'
          }
        >
          {props.children}
        </input>
        <div className={classes.searchIcon}>
          <StyledIconButton
            onClick={() => {
              handleChanges(text)
            }}
          >
            <SearchIcon />
          </StyledIconButton>
        </div>
      </div>

      {openedSuggestions && (
        <div className={classes.suggestions}>
          <ul>
            {localSuggestions.length > 0 ? (
              localSuggestions.map(s => (
                <li
                  onClick={() => {
                    setText(s)
                    handleChanges(s)
                  }}
                >
                  {s}
                </li>
              ))
            ) : (
              <li>No results found</li>
            )}
          </ul>
        </div>
      )}
    </div>
  )
}

export default injectStyles(styles)(LiveMapSearchInput)
